class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResultsArticle = this.querySelector('#predictive-searchArticle');
    this.predictiveSearchResultsProduct = this.querySelector('#predictive-searchProduct');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getQuery() {
    return this.input.value.trim();
  }

  onKeyup(event) {
		if (!this.getQuery().length){
			this.close(true);
			$('form .predictive-search-content').css("display", "none");
		}
		event.preventDefault();
	}
  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }
  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  } 

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }


  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    fetch(`/search/suggest?q=${searchTerm}&${encodeURIComponent('resources[type]')}=article&&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-articles').innerHTML;
        this.SearchResultsArticle(resultsMarkup,queryKey);
      })
      .catch((error) => {
        this.close();
        throw error;
      });

      fetch(`/search/suggest?q=${searchTerm}&${encodeURIComponent('resources[type]')}=product&&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-products').innerHTML;
        this.SearchResultsProduct(resultsMarkup,queryKey);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
	  $('form .predictive-search-content').removeAttr('style')
  }

  close(clearSearchTerm = false) { 
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
  }

  SearchResultsArticle(resultsMarkup,queryKey) {
		this.predictiveSearchResultsArticle.innerHTML = resultsMarkup;
		this.setAttribute('results', true);  
		//this.setLiveRegionResults();
		var url = '/search?q='+queryKey+'&type=article';
		$('[data-view-all-article]').attr('href', url);
		this.open();
	} 
  SearchResultsProduct(resultsMarkup,queryKey) {
		this.predictiveSearchResultsProduct.innerHTML = resultsMarkup;
		this.setAttribute('results', true);  
		//this.setLiveRegionResults();
		var url = '/search?q='+queryKey+'&type=product';
		$('#predictive-searchProduct').attr('href', url);
		this.open();
	} 
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
